export default __webpack_public_path__ + "static/media/equation.bde63a68.svg";